// extracted by mini-css-extract-plugin
module.exports = {"line":"PostExcerptMetadata-module--line--30teO"};